import AggregatedData from './aggregatedData';

export default class NavigationData {
  partialList = [];
  version = 11;
  context = {};
  total = new AggregatedData();
  daily = new AggregatedData();
  session = new AggregatedData();
  campaign = {};

  constructor(parsed) {
    if (parsed) {
      if (parsed.data && parsed.data.version && parsed.data.version === this.version) {
        this.session = { ...this.session, ...parsed.data.session };
        this.daily = { ...this.daily, ...parsed.data.daily };
        this.total = { ...this.total, ...parsed.data.total };
        this.campaign = { ...this.campaign, ...parsed.data.campaign };
      }
    }
  }

  resetSession = () => {
    this.session = new AggregatedData();
    this.session.startDate = Date.now();
  };

  resetDaily = () => {
    this.daily = new AggregatedData();
    this.daily.startDate = Date.now();
  };
}
